export default "__VITE_ASSET__306f3df5__"